import React from 'react';
import { ColumnFilter } from '@tanstack/table-core';
import { Wrap, WrapItem } from '@fiverr-private/layout_components';
import { Button } from '@fiverr-private/button';
import { Typography } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { FilterControlTag } from '../FilterControlTag';

interface TableFilterControlProps {
  filters: ColumnFilter[];
  onFilterClear: (filterId: string, value?: string) => void;
}

export const TableFilterControl = ({ filters, onFilterClear }: TableFilterControlProps) => {
  const renderTagGroup = (filter: ColumnFilter) =>
    Array.isArray(filter.value) ? (
      filter.value.map((v) => (
        <WrapItem key={v}>
          <FilterControlTag value={v} onClick={() => onFilterClear(filter.id, v)} />{' '}
        </WrapItem>
      ))
    ) : (
      <WrapItem key={filter.id}>
        <FilterControlTag value={filter.value as string} onClick={() => onFilterClear(filter.id)} />
      </WrapItem>
    );

  return (
    <Wrap alignItems="center" gap="1">
      {filters.map((filter) => (
        <>
          {!filter.id ? (
            <WrapItem key={filter.id}>
              <Button size="sm" onClick={() => onFilterClear(filter.id)} variant="ghost">
                <Typography as="p" size="b_sm" color="grey_1000">
                  <I18n k="briefs_table.table_filter_control.clear_filters" />
                </Typography>
              </Button>
            </WrapItem>
          ) : (
            renderTagGroup(filter)
          )}
        </>
      ))}
    </Wrap>
  );
};
